import React from 'react';

const Confirmation: React.FC = () => {
  return null;
};

export default Confirmation;
